import React from "react";

import { Header } from "@src/components/ui/Header";
import { Footer } from "@src/components/ui/Footer";

import styles from "./MainLayout.module.scss";

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Header onLogoClick={() => (window.location.href = "/")} />
      </div>
      <div className={styles.page}>{children}</div>
      <div className={styles.footer}>
        <Footer />
      </div>
    </div>
  );
};
